import * as ENUMS from '@/models/enums';

export const OUTGROWER_COOPERATIVE_ROLES = [
    "Leader",
    "Member",
    "Treasurer",
    "Assistant",
    "Secretary"
] as const;

export interface OutgrowerFarmer {
    first_name?: string;
    middle_name?: string;
    last_name?: string;
    phone_number?: string;
    gender?: string;
    date_of_birth?: string;
    passport_photo?: FileList | string;
    id_type?: typeof ENUMS.ID_TYPES[number];
    id_number?: string;
    id_photo?: FileList | string;
    bvn?: string;
    bvn_photo?: FileList | string;
    signature?: FileList | string;
    field_officer?: string;
    state?: string;
    lga?: string;
    cluster?: string;
    cooperative_name?: string;
    cooperative_role?: typeof OUTGROWER_COOPERATIVE_ROLES[number];
    current_credit_package?: string;
    country?: string;
    commodity?: string;
    status?: typeof ENUMS.STATUS[number];
    creation?: string;
    modified?: string;
}

export const OUTGROWER_FARMER_SCHEMA = "phone_number, first_name, middle_name, last_name, gender, date_of_birth, passport_photo, id_type, id_number, id_photo, bvn, bvn_photo, signature, field_officer, state, lga, cluster, cooperative_name, cooperative_role, current_credit_package, country, commodity, status, creation, modified";
